import styled from "styled-components";
export const ComponentPopupSurvey = () => {
    return (
        <StyledPopupSuvey>
            <div className="box-popupconfirm">
                {/* <div className="img-popupconfirm">
                    <img src="../images/img-confirm-redeem.svg" alt="" />
                </div> */}
                <div className="title">
                    <div className="text-sub-header">
                        Survey
                    </div>
                </div>
            </div>
        </StyledPopupSuvey>
    );
};

const StyledPopupSuvey = styled.div`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 30px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s!important;
        @keyframes shakebox {
            0%   {top:0px;left:0px;}
            25%  {top:-5px;left:-5px;}
            50%  {top:0;left:0;}
            75%  {top:5px;left:5px;}
            100% {top:0;left:0;}
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
    }
    .close {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
        transform: rotate(0deg);
        transition:0.6s;
        &:hover {
            transform: rotate(90deg);
        }
    }
    .title {
        display: flex;
        align-items: center;
        .image {
            width: 28px;
            margin-right: 8px;
        }
        .member {
            font-style: normal;
            color: ${(p) => p.theme.colors.color};
        }
    }
`;
